import api from '../../services/api';

// Action Types
export const FETCH_AUDITOR_REPORT_REQUEST = 'FETCH_AUDITOR_REPORT_REQUEST';
export const FETCH_AUDITOR_REPORT_SUCCESS = 'FETCH_AUDITOR_REPORT_SUCCESS';
export const FETCH_AUDITOR_REPORT_FAILURE = 'FETCH_AUDITOR_REPORT_FAILURE';

export const FETCH_AUDITOR_REPORT_SUMMARY_REQUEST = 'FETCH_AUDITOR_REPORT_SUMMARY_REQUEST';
export const FETCH_AUDITOR_REPORT_SUMMARY_SUCCESS = 'FETCH_AUDITOR_REPORT_SUMMARY_SUCCESS';
export const FETCH_AUDITOR_REPORT_SUMMARY_FAILURE = 'FETCH_AUDITOR_REPORT_SUMMARY_FAILURE';

// Profit & Loss
export const FETCH_PL_REQUEST = 'FETCH_PL_REQUEST';
export const FETCH_PL_SUCCESS = 'FETCH_PL_SUCCESS';
export const FETCH_PL_FAILURE = 'FETCH_PL_FAILURE';

// Action Creators
export const fetchAuditorReportRequest = () => ({
  type: FETCH_AUDITOR_REPORT_REQUEST
});

export const fetchAuditorReportSuccess = (data) => ({
  type: FETCH_AUDITOR_REPORT_SUCCESS,
  payload: data
});

export const fetchAuditorReportFailure = (error) => ({
  type: FETCH_AUDITOR_REPORT_FAILURE,
  payload: error
});

export const fetchAuditorReportSummaryRequest = () => ({
  type: FETCH_AUDITOR_REPORT_SUMMARY_REQUEST
});

export const fetchAuditorReportSummarySuccess = (data) => ({
  type: FETCH_AUDITOR_REPORT_SUMMARY_SUCCESS,
  payload: data
});

export const fetchAuditorReportSummaryFailure = (error) => ({
  type: FETCH_AUDITOR_REPORT_SUMMARY_FAILURE,
  payload: error
});

// Async Actions
export const fetchAuditorReport = (filters = {}) => {
  return async (dispatch) => {
    dispatch(fetchAuditorReportRequest());
    try {
      const params = new URLSearchParams();
      
      if (filters.startDate) params.append('startDate', filters.startDate);
      if (filters.endDate) params.append('endDate', filters.endDate);
      if (filters.category) params.append('category', filters.category);
      if (filters.customerId) params.append('customerId', filters.customerId);
      
      const queryString = params.toString();
      const url = queryString ? `/reports/auditor?${queryString}` : '/reports/auditor';
      
      const response = await api.get(url);
      dispatch(fetchAuditorReportSuccess(response.data.data));
      return response.data;
    } catch (error) {
      const errorMessage = error.response?.data?.message || 'Failed to fetch auditor report';
      dispatch(fetchAuditorReportFailure(errorMessage));
      throw error;
    }
  };
};

export const fetchAuditorReportSummary = (filters = {}) => {
  return async (dispatch) => {
    dispatch(fetchAuditorReportSummaryRequest());
    try {
      const params = new URLSearchParams();
      
      if (filters.startDate) params.append('startDate', filters.startDate);
      if (filters.endDate) params.append('endDate', filters.endDate);
      
      const queryString = params.toString();
      const url = queryString ? `/reports/auditor/summary?${queryString}` : '/reports/auditor/summary';
      
      const response = await api.get(url);
      dispatch(fetchAuditorReportSummarySuccess(response.data.data));
      return response.data;
    } catch (error) {
      const errorMessage = error.response?.data?.message || 'Failed to fetch auditor report summary';
      dispatch(fetchAuditorReportSummaryFailure(errorMessage));
      throw error;
    }
  };
};

// Fetch Profit & Loss
export const fetchProfitAndLoss = (basis = 'accrual', filters = {}) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_PL_REQUEST });
    try {
      const params = new URLSearchParams();
      if (filters.startDate) params.append('startDate', filters.startDate);
      if (filters.endDate) params.append('endDate', filters.endDate);
      const path = basis === 'cash' ? '/reports/pl/cash' : '/reports/pl/accrual';
      const url = params.toString() ? `${path}?${params.toString()}` : path;
      const response = await api.get(url);
      dispatch({ type: FETCH_PL_SUCCESS, payload: { basis, ...response.data.data } });
      return response.data;
    } catch (error) {
      const errorMessage = error.response?.data?.message || 'Failed to fetch profit & loss';
      dispatch({ type: FETCH_PL_FAILURE, payload: errorMessage });
      throw error;
    }
  };
};
